import { Card } from "@mui/material";
import { useEffect, useState } from "react";

import Box from "../../components/Box";
import Helpers from "../../commons/helpers";
import Button from "../../components/Button";
import useStrings from "../../hooks/useStrings";
import Typography from "../../components/Typography";
import Autocomplete from "../../components/Autocomplete";
import useContainerStaff from "../../hooks/useContainerStaff";
import UserRoleService from "../../services/identity/userRole.service";


import { Mode } from "../../constants/enums";
import { ICodename } from "../../commons/interfaces";
import { RoleHelpers } from "../../commons/roleHelpers";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";


const CardUserRole = (props: {
    mode: number;
    userId?: string;
    requiredRole?: boolean;
    organizationId?: string;

    newLableGroup?: string;
    newLableStaff?: string;
    dataUserRole?: string[];
    dataRoleSelect?: ICodename[];
    dataUserRoleDisable?: string[];

    onCallBack?: (data: { roleCodes?: string[], isGetUserGroup?: boolean }) => void;
}) => {
    const strings = useStrings();

    const { isPermissionCheckGroupManager } = useContainerStaff();

    const {
        clientId,
        userInfo,
        onError,
        onSuccess,
        onShowLoading,
        onHideLoading,
    } = useCommonComponentContext();

    const [errorRole, setErrorRole] = useState<string>("");
    const [dataUserRoles, setDataUserRoles] = useState<string[]>([]);
    const [modeUserRole, setModeUserRole] = useState<number>(Mode.View);

    useEffect(() => {
        setModeUserRole(props.mode);
    }, [props.mode]);

    useEffect(() => {
        setErrorRole("");
        setDataUserRoles(props.dataUserRole);
    }, [props.dataUserRole]);

    const handleOnClick = () => {
        if (modeUserRole === Mode.View) {
            setModeUserRole(Mode.Update);
        } else {
            if (isPermissionCheckGroupManager([...props.dataRoleSelect || []], [...props.dataUserRole || []])) {
                if (!isPermissionCheckGroupManager([...props.dataRoleSelect || []], [...dataUserRoles || []])) {
                    const str = strings.format(strings.Staff.CHANGE_ROLE, props.newLableStaff, props.newLableGroup, props.newLableGroup);

                    Helpers.showConfirmAlert(
                        Helpers.capitalizeFirstLetter(str),
                        async () => { await handleUpdateUserRole(true); }
                    );
                } else {
                    handleUpdateUserRole(false)
                }
            } else {
                handleUpdateUserRole(false)
            }
        }
    };

    const handleUpdateUserRole = async (isGetUserGroup: boolean) => {
        let newRoleCodes: string[] = [...dataUserRoles || []];

        if (
            props.requiredRole &&
            (Helpers.isNullOrEmpty(dataUserRoles) || newRoleCodes.length === 0)
        ) {
            setErrorRole(strings.Common.REQUIRED);
        } else {
            try {
                onShowLoading();


                if (newRoleCodes.length === 0) {
                    const itemRoleMember = [...props.dataRoleSelect || []].find(el => (
                        RoleHelpers.isOrganizationMember(el.detail?.roleType)
                    ));

                    itemRoleMember &&
                        newRoleCodes.push(itemRoleMember?.code as string);
                }

                const newReq: any = {
                    clientId: clientId,
                    userId: props?.userId,
                    organizationId: props?.organizationId,
                    roleCodes: newRoleCodes,
                };

                await UserRoleService.update(newReq);

                setModeUserRole(Mode.View);

                props.onCallBack &&
                    await props.onCallBack({
                        roleCodes: newReq.roleCodes,
                        isGetUserGroup: isGetUserGroup,
                    });

                onSuccess(strings.format(strings.Staff.UPDATE_STAFF_ROLE_SUCCESS, props.newLableStaff));
            } catch (error) {
                const e = Helpers.renderExceptionError(error);
                onError(e);
            } finally {
                onHideLoading();
            }
        }
    }

    return (
        <Card>
            <Box p={2}>
                <Box display="flex" flexWrap="wrap" alignItems="center" justifyContent="space-between" >
                    <Typography variant="h5">{strings.Staff.ROLE}</Typography>
                    {
                        (props.mode !== Mode.View) &&
                        !Helpers.isNullOrEmpty(props.userId) &&
                        <Box gap={1} display="flex" flexWrap="wrap" alignItems="center">
                            {
                                (modeUserRole !== Mode.View) &&
                                <Button
                                    color="secondary"
                                    onClick={() => {
                                        setErrorRole("");
                                        setModeUserRole(Mode.View);
                                        setDataUserRoles([...props.dataUserRole || []]);
                                    }}>
                                    {strings.Common.CANCEL}
                                </Button>
                            }
                            <Button
                                onClick={handleOnClick}>
                                {(modeUserRole === Mode.View) ? strings.Common.EDIT : strings.Common.SAVE}
                            </Button>
                        </Box>
                    }
                </Box>
                <Box p={2}>
                    <Autocomplete
                        multiple
                        isFullRow
                        isGroupBy
                        mode={modeUserRole}
                        errorMessage={errorRole}
                        defaultValue={dataUserRoles}
                        required={props.requiredRole}
                        label={strings.format(strings.Staff.STAFF_PERMISSION, props.newLableStaff)}
                        placeholder={strings.format(strings.Staff.SELECT_STAFF_PERMISSION, props.newLableStaff)}
                        onChange={(value: any) => {
                            setErrorRole("");
                            if (Helpers.isNullOrEmpty(value) || [...value || []].length === 0) {
                                setDataUserRoles([...props.dataUserRoleDisable || []]);
                            } else {
                                const newValue = [...value || []];
                                for (const code of [...props.dataUserRoleDisable || []]) {
                                    ![...value || []].includes(code)
                                        && newValue.push(code);
                                }
                                setDataUserRoles(newValue);
                            }
                        }}
                        data={[...props.dataRoleSelect || []]}
                        optionDisabled={[
                            ...props.dataRoleSelect.filter(el => (
                                RoleHelpers.isOrganizationOwner(el.detail?.roleType)
                            ))?.map(e => `${e.code}`) || []
                        ]}
                    />
                </Box>
            </Box>
        </Card>
    );
};

export default CardUserRole;